/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

export const Logo = ({ logo, logoDimensions, style, className, onClick }) => {
    const color = style.colour;

    let steez = { cursor: style.cursor };

    if (null != logoDimensions) {
        steez.width = logoDimensions.width;
        steez.height = logoDimensions.height;
        steez.float = 'left';
    }

    return (
        <div
            className={`logo ${color} ${className}`}
            style={steez}
            onClick={() => {
                onClick();
            }}
        >
            {color === 'black' && (
                <img
                    className="duo-digital-und"
                    alt="Duo digital und"
                    src="/img/duo-digital-und-offen-black-2x-1.png"
                />
            )}
        </div>
    );
};

Logo.propTypes = {
    logo: PropTypes.oneOf(['DUO']),
    color: PropTypes.oneOf(['black', 'default']),
};
